module.exports = __webpack_public_path__ + "media/auto_history/zmiana_wlasciciela-0d45ad8d.svg";